/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Online_Task_Split_TitleInputs */

const en_pc_online_task_split_title = /** @type {(inputs: Pc_Online_Task_Split_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Split or extract pages`)
};

const zh_pc_online_task_split_title = /** @type {(inputs: Pc_Online_Task_Split_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`拆分或提取页面`)
};

/**
* | output |
* | --- |
* | "Split or extract pages" |
*
* @param {Pc_Online_Task_Split_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_online_task_split_title = /** @type {((inputs?: Pc_Online_Task_Split_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Online_Task_Split_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_online_task_split_title(inputs)
	return zh_pc_online_task_split_title(inputs)
});
export { pc_online_task_split_title as "pc.online.task.split.title" }